"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SlideTitle;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/styles");

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Components


var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    dialogTitleRoot: {
      '& > h6': {
        display: 'flex',
        justifyContent: 'space-between'
      }
    },
    subtitle: theme.typography.body1
  });
});

function SlideTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      titleActions = _ref.titleActions;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    classes: {
      root: classes.dialogTitleRoot
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, title, subtitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.subtitle
  }, subtitle)), /*#__PURE__*/_react["default"].createElement("div", null, titleActions));
}